var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 5 18" }, props),
    React.createElement("circle", { className: styles["oc-icon-indicator"] || "oc-icon-indicator", cx: "2.5", cy: "15.6", r: "2.4" }),
    React.createElement("path", { className: styles["oc-icon-indicator"] || "oc-icon-indicator", d: "M2.5 11.2c-1.1 0-2-.9-2-2V2c0-1.1.9-2 2-2s2 .9 2 2v7.3c0 1-.9 1.9-2 1.9z" })
  );
});


// WEBPACK FOOTER //
// ./icons/images/indicators/Exclamation.svg